/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    GroupDto,
    GroupDtoFromJSON,
    GroupDtoToJSON,
    IdentityDto,
    IdentityDtoFromJSON,
    IdentityDtoToJSON,
} from '../models';

export interface AddIdentityRequest {
    group: string;
    type: string;
    storePwd: Array<string>;
    keyPwd: Array<string>;
    file: Blob;
}

export interface ChangeActiveIdentityRequest {
    group: string;
    thumbPrint: string;
}

export interface DeleteGroupRequest {
    group: string;
}

export interface DeleteIdentityRequest {
    group: string;
    thumbPrint: string;
}

export interface DownloadIdentityCARequest {
    group: string;
    thumbPrint: string;
}

export interface ListGroupRequest {
    group: string;
}

/**
 * 
 */
export class IdentityRestControllerApi extends runtime.BaseAPI {

    /**
     */
    async addIdentityRaw(requestParameters: AddIdentityRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.group === null || requestParameters.group === undefined) {
            throw new runtime.RequiredError('group','Required parameter requestParameters.group was null or undefined when calling addIdentity.');
        }

        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new runtime.RequiredError('type','Required parameter requestParameters.type was null or undefined when calling addIdentity.');
        }

        if (requestParameters.storePwd === null || requestParameters.storePwd === undefined) {
            throw new runtime.RequiredError('storePwd','Required parameter requestParameters.storePwd was null or undefined when calling addIdentity.');
        }

        if (requestParameters.keyPwd === null || requestParameters.keyPwd === undefined) {
            throw new runtime.RequiredError('keyPwd','Required parameter requestParameters.keyPwd was null or undefined when calling addIdentity.');
        }

        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling addIdentity.');
        }

        const queryParameters: any = {};

        if (requestParameters.group !== undefined) {
            queryParameters['group'] = requestParameters.group;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.storePwd) {
            queryParameters['storePwd'] = requestParameters.storePwd;
        }

        if (requestParameters.keyPwd) {
            queryParameters['keyPwd'] = requestParameters.keyPwd;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/api/pkix/add-identity`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async addIdentity(group: string, type: string, storePwd: Array<string>, keyPwd: Array<string>, file: Blob, initOverrides?: RequestInit): Promise<void> {
        await this.addIdentityRaw({ group: group, type: type, storePwd: storePwd, keyPwd: keyPwd, file: file }, initOverrides);
    }

    /**
     */
    async changeActiveIdentityRaw(requestParameters: ChangeActiveIdentityRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.group === null || requestParameters.group === undefined) {
            throw new runtime.RequiredError('group','Required parameter requestParameters.group was null or undefined when calling changeActiveIdentity.');
        }

        if (requestParameters.thumbPrint === null || requestParameters.thumbPrint === undefined) {
            throw new runtime.RequiredError('thumbPrint','Required parameter requestParameters.thumbPrint was null or undefined when calling changeActiveIdentity.');
        }

        const queryParameters: any = {};

        if (requestParameters.group !== undefined) {
            queryParameters['group'] = requestParameters.group;
        }

        if (requestParameters.thumbPrint !== undefined) {
            queryParameters['thumbPrint'] = requestParameters.thumbPrint;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/pkix/change-identity`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async changeActiveIdentity(group: string, thumbPrint: string, initOverrides?: RequestInit): Promise<void> {
        await this.changeActiveIdentityRaw({ group: group, thumbPrint: thumbPrint }, initOverrides);
    }

    /**
     */
    async deleteGroupRaw(requestParameters: DeleteGroupRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.group === null || requestParameters.group === undefined) {
            throw new runtime.RequiredError('group','Required parameter requestParameters.group was null or undefined when calling deleteGroup.');
        }

        const queryParameters: any = {};

        if (requestParameters.group !== undefined) {
            queryParameters['group'] = requestParameters.group;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/pkix/delete-group`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteGroup(group: string, initOverrides?: RequestInit): Promise<void> {
        await this.deleteGroupRaw({ group: group }, initOverrides);
    }

    /**
     */
    async deleteIdentityRaw(requestParameters: DeleteIdentityRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.group === null || requestParameters.group === undefined) {
            throw new runtime.RequiredError('group','Required parameter requestParameters.group was null or undefined when calling deleteIdentity.');
        }

        if (requestParameters.thumbPrint === null || requestParameters.thumbPrint === undefined) {
            throw new runtime.RequiredError('thumbPrint','Required parameter requestParameters.thumbPrint was null or undefined when calling deleteIdentity.');
        }

        const queryParameters: any = {};

        if (requestParameters.group !== undefined) {
            queryParameters['group'] = requestParameters.group;
        }

        if (requestParameters.thumbPrint !== undefined) {
            queryParameters['thumbPrint'] = requestParameters.thumbPrint;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/pkix/delete-identity`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteIdentity(group: string, thumbPrint: string, initOverrides?: RequestInit): Promise<void> {
        await this.deleteIdentityRaw({ group: group, thumbPrint: thumbPrint }, initOverrides);
    }

    /**
     */
    async downloadIdentityCARaw(requestParameters: DownloadIdentityCARequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.group === null || requestParameters.group === undefined) {
            throw new runtime.RequiredError('group','Required parameter requestParameters.group was null or undefined when calling downloadIdentityCA.');
        }

        if (requestParameters.thumbPrint === null || requestParameters.thumbPrint === undefined) {
            throw new runtime.RequiredError('thumbPrint','Required parameter requestParameters.thumbPrint was null or undefined when calling downloadIdentityCA.');
        }

        const queryParameters: any = {};

        if (requestParameters.group !== undefined) {
            queryParameters['group'] = requestParameters.group;
        }

        if (requestParameters.thumbPrint !== undefined) {
            queryParameters['thumbPrint'] = requestParameters.thumbPrint;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/pkix/download-identity-ca`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async downloadIdentityCA(group: string, thumbPrint: string, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.downloadIdentityCARaw({ group: group, thumbPrint: thumbPrint }, initOverrides);
        return await response.value();
    }

    /**
     */
    async listGroupRaw(requestParameters: ListGroupRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GroupDto>> {
        if (requestParameters.group === null || requestParameters.group === undefined) {
            throw new runtime.RequiredError('group','Required parameter requestParameters.group was null or undefined when calling listGroup.');
        }

        const queryParameters: any = {};

        if (requestParameters.group !== undefined) {
            queryParameters['group'] = requestParameters.group;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/pkix/group`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupDtoFromJSON(jsonValue));
    }

    /**
     */
    async listGroup(group: string, initOverrides?: RequestInit): Promise<GroupDto> {
        const response = await this.listGroupRaw({ group: group }, initOverrides);
        return await response.value();
    }

    /**
     */
    async listGroupsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<GroupDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/pkix/groups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GroupDtoFromJSON));
    }

    /**
     */
    async listGroups(initOverrides?: RequestInit): Promise<Array<GroupDto>> {
        const response = await this.listGroupsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async listIdentitiesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<IdentityDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/pkix/identities`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IdentityDtoFromJSON));
    }

    /**
     */
    async listIdentities(initOverrides?: RequestInit): Promise<Array<IdentityDto>> {
        const response = await this.listIdentitiesRaw(initOverrides);
        return await response.value();
    }

}
